import { BusinessHealthResponse } from '../../types';

const getLabels = (
    key: string,
    data?: BusinessHealthResponse,
) => data?.labels?.components?.[key] || data?.labels?.metrics?.[key];

export default getLabels;
